import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap";
import Logo from '../assets/images/logo33.png'
import LogoMB from '../assets/images/logo.8.black.svg'
import Social1 from '../assets/images/st1.png'
import Social2 from '../assets/images/st2.png'
import Social3 from '../assets/images/st3.png'
import Social4 from '../assets/images/st4.png'
import Social5 from '../assets/images/st5.png'
import Media from 'react-media';
import { Link } from 'react-scroll'

const Menu = () => {
	return (

		<header className="flex-wrap align-items-center justify-content-center ">



			<Navbar bg="" expand="lg">

					<Navbar.Brand href="/">
					<img className="logo_mb" src={LogoMB} alt="logo" />

				<img className="logo_pc" src={Logo} alt="logo" />


					</Navbar.Brand>

					<Navbar.Toggle aria-controls="basic-navbar-nav" />
					<Navbar.Collapse id="basic-navbar-nav">
						<Nav >

						<Link href="/#"   to="ticket" spy={true} smooth={true} duration={300} className="nav-link">

																				TICKET PRICES

                                    </Link>
							{/* <Nav.Link href="https://survey.connect.mandala.global/home/index?id=76&NewSession=1" target={'_blank'}>TICKET PRICES</Nav.Link> */}

							{/* <Nav.Link href="#">ARTISTE LINEUP</Nav.Link> */}
							<Link href="/#"   to="lineup" spy={true} smooth={true} duration={300} className="nav-link">

							ARTISTE LINEUP

</Link>



							<Nav.Link href="mailto:enquiries@mandalamasters.com">CONTACT US</Nav.Link>
						</Nav>
					</Navbar.Collapse>

					<ul className="social_top">
						<li>
							<a href="https://www.facebook.com/mandalaweekender" target="_black"><img src={Social1} alt="social" /></a>
						</li>
						<li>
							<a href="https://www.instagram.com/mandalaweekender/" target="_black"><img src={Social2} alt="social" /></a>
						</li>
						{/* <li>
							<a href="#" target="_black"><img src={Social3} alt="social" /></a>
						</li>
						<li>
							<a href="#" target="_black"><img src={Social4} alt="social" /></a>
						</li>
						<li>
							<a href="#" target="_black"><img src={Social5} alt="social" /></a>
						</li> */}
					</ul>

			</Navbar>
		</header>

	);
};

export default Menu;
